<section-panel paddings="medium">
  <span class="button-label">{{ title }}</span>
  <ng-container [ngSwitch]="variant">
    <ion-icon *ngSwitchCase="'external'" name="open" class="arrow external-arrow"></ion-icon>
    <ion-icon *ngSwitchDefault size="medium" src="assets/dropdown_arrow.svg" class="arrow"></ion-icon>
  </ng-container>
</section-panel>